import React, { Component, ReactNode } from 'react';

interface Props  { children: ReactNode; }
interface State  { hasError: boolean; error?: Error; }

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ErrorBoundary]', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-screen bg-navy flex flex-col items-center justify-center text-center px-6">
        <p className="font-syne font-extrabold text-teal/10 leading-none select-none mb-6"
          style={{ fontSize: 'clamp(6rem, 20vw, 14rem)' }}>
          500
        </p>
        <h1 className="font-syne text-white font-bold text-2xl mb-3 -mt-6">
          Ceva nu a mers bine
        </h1>
        <p className="text-silver text-sm mb-8 max-w-sm">
          A apărut o eroare neașteptată. Te rugăm să reîncarci pagina.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="bg-teal text-navy font-syne font-bold px-6 py-3 rounded-md
            hover:bg-teal-light transition-colors">
          Reîncarcă pagina
        </button>
        {process.env.NODE_ENV === 'development' && this.state.error && (
          <pre className="mt-8 text-left text-xs text-red-400 bg-white/5 p-4 rounded-md max-w-2xl overflow-auto">
            {this.state.error.stack}
          </pre>
        )}
      </div>
    );
  }
}
